module.exports = {"bewizr-agenda":{"empty":{"title":"Etkinlik yok","detail":"Planlanmış etkinliğiniz yok."}}}